<highcharts-chart
  data-at-chart
  *ngIf="diagnosticsChartService.currentSeriesLength | async"
  [Highcharts]="highcharts"
  [options]="diagnosticsChartService.chartOptions"
  [update]="diagnosticsChartService.updateFlag | async"
  (updateChange)="updateChange($event)"
  constructorType="stockChart"
  [oneToOne]="true"
  class="chart-container"
></highcharts-chart>
